import axios from './utils/axios';
import { utils } from 'gipsy-misc';

export var get = function get(id) {
  var endpoint = '/tasks/' + id;
  return axios.get(endpoint);
};

export var update = function update(id, body) {
  var endpoint = '/tasks/' + id;
  return axios.put(endpoint, body);
};

export var patch = function patch(id, params, body) {
  var endpoint = '/tasks/' + id;
  endpoint = utils.request.appendToUrl(endpoint, params);
  return axios.patch(endpoint, body);
};

export var create = function create(body, context) {
  var endpoint = '/tasks';
  var headers = utils.request.makeContextHeaders(context);
  return axios.post(endpoint, body, { headers: headers });
};

export var del = function del(id) {
  var deleteMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'standard';

  var endpoint = '/tasks/' + id;
  endpoint = utils.request.appendToUrl(endpoint, { deleteMode: deleteMode });
  return axios.delete(endpoint);
};

export var complete = function complete(id, context, params) {
  var endpoint = '/tasks/complete/' + id;
  var headers = utils.request.makeContextHeaders(context);
  if (params) {
    endpoint = utils.request.appendToUrl(endpoint, params);
  }
  return axios.post(endpoint, null, { headers: headers });
};

export var uncomplete = function uncomplete(id) {
  var endpoint = '/tasks/uncomplete/' + id;
  return axios.post(endpoint);
};

export var dragAndDrop = function dragAndDrop(body) {
  var endpoint = '/tasks/drag-and-drop';
  return axios.post(endpoint, body);
};

export var dragAndDropForTeam = function dragAndDropForTeam(body) {
  var endpoint = '/tasks/team/drag-and-drop';
  return axios.post(endpoint, body);
};

export var uploads = {
  request: function request() {
    var endpoint = '/uploads/requests';
    return axios.get(endpoint);
  },
  delete: function _delete(taskId, fileId) {
    var endpoint = '/tasks/' + taskId + '/uploads/' + fileId;
    return axios.delete(endpoint);
  },
  images: {
    request: function request() {
      var endpoint = '/uploads/images/requests';
      return axios.get(endpoint);
    }
  }
};

export var approveReview = function approveReview(id) {
  var endpoint = '/tasks/review/approve/' + id;
  return axios.post(endpoint);
};

export var reopenReview = function reopenReview(id) {
  var endpoint = '/tasks/review/reopen/' + id;
  return axios.post(endpoint);
};

export var createRequestReview = function createRequestReview(body) {
  var endpoint = '/tasks/review/request';
  return axios.post(endpoint, body);
};

export var getReview = function getReview(link) {
  var endpoint = '/reviews';
  if (link) {
    endpoint = utils.request.appendToUrl(endpoint, { link: link });
  }
  return axios.get(endpoint);
};
//# sourceMappingURL=task.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-api/lib/task.js
// module id = 1087
// module chunks = 0